<template>
  <div class="fix">
    <img
      class="slide-lemon"
      style="width: 0.97rem;
      margin-bottom: -0.45rem;
      margin-left: -0.07rem;
      z-index: 9999;"
      src="../../assets/image/slide-lemon.png"
    />
    <div class="fix-menu">
      <div class="fix-menu-box">
        <div class="fix-menu-item fix-menu-item-tel cus-pointer">
          <img
            style="width: 0.3rem;height: 0.3rem;margin-top: 0.4rem"
            src="../../assets/image/slide-mobile.png"
          />
          <span>电话咨询</span>
          <div class="tel-box-div">
            <div
            class="tel-box"
            style="font-size: 0.16rem;background: white"
          >
            <div style="margin-bottom: 0.1rem;">拨打热线联系我们</div>
            <div style="font-size: 0.2rem">18617131848</div>
          </div>
          </div>
        </div>
        <div class="hr"></div>
        <div class="fix-menu-item fix-menu-item-wx cus-pointer">
          <img
            style="width: 0.3rem;height: 0.3rem"
            src="../../assets/image/slide-code.png"
          />
          <span>联系我们</span>
          <div class="wx-box-div">
            <div
            class="wx-box"
            style="font-size: 0.16rem;background: white"
          >
            <img
              style="margin:0;width: 1.3rem"
              src="@/assets/image/index/wx-public.jpg"
            />
            <div style="color: black">扫码联系我们</div>
          </div>
          </div>
        </div>
        <div class="hr"></div>
        <div class="fix-menu-item cus-pointer" @click="backTop()">
          <img
            style="width: 0.2356rem;height: 0.3rem"
            src="../../assets/image/slide-top.png"
          />
          <span>置顶</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Slide",
  methods: {
    backTop() {
      window.scrollTo({
        top: 0,
        behavior: "smooth" // 平滑滚动
      });
    }
  }
};
</script>

<style scoped lang="scss">
.fix {
  position: fixed;
  //top: 50%;
  right: 0.3rem;
  bottom: 0.5rem;
  //transform: translateY(-50%); /* 通过位移修正垂直居中偏移 */
  display: flex;
  flex-direction: column;
}

.slide-lemon {
}

.fix-menu {
  font-weight: 400;
  font-size: 0.14rem;
  color: #3b5377;
  z-index: 999;
  border-radius: 0.04rem;
  width: 0.76rem;

  .fix-menu-box {
    background: #dbe002;
    .fix-menu-item-tel{
      .tel-box-div{
        position: absolute;
        right: 0;
        padding-right: 1rem;
        display: none;
      }
      .tel-box {
        font-size: 0.16rem;
        background: white;
        width: 2.3rem;
        text-align: center;
        border-radius: 0.05rem;
        padding: 0.1rem 0;
      }
      &:hover {
        .tel-box-div {
          display: block;
        }
      }
    }
    .fix-menu-item-wx {
      .wx-box-div{
        position: absolute;
        right: 0;
        padding-right: 1rem;
        display: none;
      }
      .wx-box {
        background: white;
        width: 1.7rem;
        text-align: center;
        border-radius: 0.05rem;
        margin-bottom: 0;
        margin-top: 0;
        padding: 0.2rem 0;
        bottom: 0;
      }
      &:hover {
        .wx-box-div {
          display: block;
        }
      }
    }
    .fix-menu-item {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      position: relative;

      img {
        margin-bottom: 0.1rem;
        margin-top: 0.2rem;
      }

      span {
        margin-bottom: 0.2rem;
      }
    }
  }
}

.hr {
  border-bottom: 0.01rem solid #999999;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/slide/Slide.vue